var _g, _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFrameworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 221,
    viewBox: "0 0 341 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36112_39798)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    width: 150,
    height: 150,
    rx: 75,
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.667 49.8915C200.275 47.4999 196.133 49.1332 196.133 52.4582V72.8165C196.133 81.3332 203.367 88.3915 212.175 88.3915C217.717 88.4499 225.417 88.4499 232.008 88.4499C235.333 88.4499 237.083 84.5415 234.75 82.2082C226.35 73.7499 211.3 58.5249 202.667 49.8915Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.083 96.442H213.225C199.4 96.442 188.142 85.1837 188.142 71.3587V54.5003C188.142 51.292 185.517 48.667 182.308 48.667H157.575C139.608 48.667 125.083 60.3337 125.083 81.1587V132.842C125.083 153.667 139.608 165.334 157.575 165.334H203.425C221.392 165.334 235.917 153.667 235.917 132.842V102.275C235.917 99.067 233.292 96.442 230.083 96.442ZM177.583 140.542H154.25C151.858 140.542 149.875 138.559 149.875 136.167C149.875 133.775 151.858 131.792 154.25 131.792H177.583C179.975 131.792 181.958 133.775 181.958 136.167C181.958 138.559 179.975 140.542 177.583 140.542ZM189.25 117.209H154.25C151.858 117.209 149.875 115.225 149.875 112.834C149.875 110.442 151.858 108.459 154.25 108.459H189.25C191.642 108.459 193.625 110.442 193.625 112.834C193.625 115.225 191.642 117.209 189.25 117.209Z",
    fill: "#CBD5E1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 173,
    width: 341,
    height: 8,
    rx: 4,
    fill: "#E2E8F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 193,
    width: 232,
    height: 8,
    rx: 4,
    fill: "#E2E8F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 213,
    width: 137,
    height: 8,
    rx: 4,
    fill: "#E2E8F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36112_39798"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    width: 150,
    height: 150,
    rx: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFrameworks);
export default __webpack_public_path__ + "static/media/no-frameworks.f534372724afab309d908625dcc849a8.svg";
export { ForwardRef as ReactComponent };